const throttleState = new Map();

export const DEFAULT_THROTTLE_WINDOW_MS = 60 * 1000;

export function resetServerLogThrottle() {
  throttleState.clear();
}

export function logServerMessageThrottled({
  key,
  level = "warn",
  message,
  logger = console,
  now = Date.now(),
  windowMs = DEFAULT_THROTTLE_WINDOW_MS,
}) {
  const entry = throttleState.get(key);
  const logFn = logger[level] || logger.warn || (() => {});

  if (!entry || now - entry.lastLoggedAt >= windowMs) {
    if (entry && entry.suppressedCount > 0) {
      logFn(
        `${message} (suppressed ${entry.suppressedCount} similar messages in last ${Math.round(windowMs / 1000)}s)`
      );
      throttleState.set(key, {lastLoggedAt: now, suppressedCount: 0});
      return;
    }

    logFn(message);
    throttleState.set(key, {lastLoggedAt: now, suppressedCount: 0});
    return;
  }

  entry.suppressedCount += 1;
}
